module.exports = __webpack_public_path__ + "img/RotaryClubofGoderichLogo.7b3f54b3.png";